"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plidMap = void 0;
const plidMap = exports.plidMap = {
  'GoDaddy': 1,
  '123 Reg': 587240,
  'Afternic': 497036
};